import { render, staticRenderFns } from "./WorkOrderForm.vue?vue&type=template&id=b08c3a56&"
import script from "./WorkOrderForm.vue?vue&type=script&lang=js&"
export * from "./WorkOrderForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports